var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuDarkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11215",
    "data-name": "Group 11215",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.529,
    height: 13.67,
    viewBox: "0 0 19.529 13.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4117",
    "data-name": "Rectangle 4117",
    width: 19.529,
    height: 13.67,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11214",
    "data-name": "Group 11214",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1343",
    "data-name": "Path 1343",
    d: "M9.768,1.95H1.117a1.077,1.077,0,0,1-.821-.3A.954.954,0,0,1,.367.21,1.214,1.214,0,0,1,1.041,0a1.33,1.33,0,0,1,.137,0Q9.792,0,18.4,0a1.719,1.719,0,0,1,.436.056.894.894,0,0,1,.676.766.909.909,0,0,1-.394.916,1.09,1.09,0,0,1-.612.207c-.056,0-.112,0-.168,0H9.768",
    transform: "translate(-0.003 0)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1344",
    "data-name": "Path 1344",
    d: "M9.792,144q4.3,0,8.605,0a1.784,1.784,0,0,1,.407.046.934.934,0,0,1,.72.847.979.979,0,0,1-.625.969,1.425,1.425,0,0,1-.507.086H1.12a1.078,1.078,0,0,1-.833-.308A.953.953,0,0,1,.373,144.2a1.221,1.221,0,0,1,.676-.2c.05,0,.1,0,.153,0h8.59",
    transform: "translate(0 -132.278)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1345",
    "data-name": "Path 1345",
    d: "M10.07,74.059q-4.287,0-8.573,0A2.051,2.051,0,0,1,1.046,74a.936.936,0,0,1-.036-1.808,1.68,1.68,0,0,1,.435-.062q8.627,0,17.253,0a1.229,1.229,0,0,1,.562.114.921.921,0,0,1,.555.862.934.934,0,0,1-.69.889,1.766,1.766,0,0,1-.465.062q-4.294.005-8.589,0",
    transform: "translate(-0.306 -66.258)",
    fill: "#0094d1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDarkIcon);
export default __webpack_public_path__ + "static/media/menu-dark-icon.bc571dc83a8236ccd357a7a4597ea919.svg";
export { ForwardRef as ReactComponent };